import {
	CUSTOM_INTEGRATION_URL,
	CUSTOM_INTEGRATION_JSON_URL,
} from 'utils/AllURLs'

export default (id, type) =>
	type === 'json'
		? `
curl --location --request POST '${CUSTOM_INTEGRATION_JSON_URL}/${id}' \
--header 'Content-Type: application/json' \
--data-raw '{
    "first_name": "Tolleen",
    "last_name": "Integration",
    "phone": "6095554466",
    "ABrandNewAttributeNeverBeforeSeen": "Yes",
    "color": "orange",
    "favorite_dinner": "The Bacon Double Cheeseburger",
    "where_are_you": "at a store",
    "favorite_letter": "G"
}'
`
		: `
curl --location --request POST '${CUSTOM_INTEGRATION_URL}/${id}' \
--header 'Content-Type: application/x-www-form-urlencoded' \
--data-urlencode 'first_name=Tolleen' \
--data-urlencode 'last_name=Integration' \
--data-urlencode 'phone=6095554466' \
--data-urlencode 'ABrandNewAttributeNeverBeforeSeen=Yes' \
--data-urlencode 'color=orange' \
--data-urlencode 'favorite_dinner=The Bacon Double Cheeseburger' \
--data-urlencode 'where_are_you=at a store' \
--data-urlencode 'favorite_letter=G'
`
